import styled from 'styled-components';

interface FieldSetContainerProps {
  fieldsVisible: boolean;
}

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  a {
    color: ${(props) => props.color};
    font-size: 13px;
    cursor: pointer;
  }
  span{
    font-size: 13px;
  }

  .field {
    background-color: ${(props) => props.theme.colors.background};
    border: none;
    width: 100%;
    border-radius: 24px;
    padding: 0.8rem 1rem;
    font-size: 14px;
    color: ${(props) => props.theme.colors.placeholder};

    ::placeholder {
      color: ${(props) => props.theme.colors.placeholder};
    }

    :focus {
      outline: none;
      color: ${(props) => props.theme.colors.title};
      border: none;
    }

    :disabled {
      background-color: ${(props) => props.theme.colors.inputBackground};
      color: ${(props) => props.theme.colors.placeholder};
    }
  }

  .text-area {
    border-radius: 8px;
    height: 120px;
  }

  // Sobrescrevendo classes do antd para radio e checkbox
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus+.ant-checkbox-inner,
  .ant-checkbox-checked::after {
    border-color: ${(props) => props.color};
    border-radius: 50%;
  }
  
  .ant-checkbox-inner{
    border-radius: 50%;
    border-color: ${({theme}) => theme.colors.placeholder}
  }
  
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({color}) => color};
    border-color: ${({color}) => color};
    border-radius: 50%;
  }

  .ant-radio-wrapper:hover .ant-radio-inner,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus+.ant-radio-inner,
  .ant-radio-checked::after {
    border-color: ${(props) => props.color};
  }
  
  .ant-radio-inner{
    border-color: ${({theme}) => theme.colors.placeholder}
  }
  
  .ant-radio-checked .ant-radio-inner {
    border-color: ${({color}) => color};
  }

  .ant-radio-inner::after {
    background-color: ${({color}) => color};
  }
`;

export const Input = styled.input`
  background-color: ${(props) => props.theme.colors.background};
  border: none;
  border-radius: 24px;
  width: 100%;
  padding: 0.8rem 1rem;
  font-size: 14px;
  color: ${(props) => props.theme.colors.placeholder};

  :disabled {
    background-color: ${(props) => props.theme.colors.inputBackground};
    color: ${(props) => props.theme.colors.placeholder};
  }

  ::placeholder {
    color: ${(props) => props.theme.colors.placeholder};
  }

  :focus {
    outline: none;
    color: ${(props) => props.theme.colors.title};
  }
`;


export const FieldSetContainer = styled.div<FieldSetContainerProps>`
  display: ${({fieldsVisible}) => fieldsVisible ? 'flex' : 'none'};
  flex-direction: column;
  gap: 16px;
`;
